import styleClasses from './ImportStatus.module.css';

export default function ImportStatus({status, t}) {
    switch (status) {
        case 0: return <span className={styleClasses.requestedStatus}>{t("ADMINISTRATION_IMPORT_STATUS_REQUESTED")}</span>
        case 1: return <span className={styleClasses.doneStatus}>{t("ADMINISTRATION_IMPORT_STATUS_DONE")}</span>
        case 2: return <span className={styleClasses.rejectedStatus}>{t("ADMINISTRATION_IMPORT_STATUS_REJECTED")}</span>
        default: return <></>
    }
}